export * from './residenceDocInfoDossier.component';
